module.exports = __webpack_public_path__ + "img/00_Main.2f90507.png";